import styled from 'styled-components'

const Block = styled.video`
  position: relative;
  object-fit: cover;
`

export default { Block }
